import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface CreateEssayState {
  isLoading: boolean;
  isSuccess: boolean;
  setIsLoading: (loading: boolean) => void;
  setIsSuccess: (status: boolean) => void;
  resetCreateEssay: () => void;
}

export const useCreateEssayStore = create<CreateEssayState>()(
  persist(
    (set) => ({
      isLoading: false,
      isSuccess: false,
      setIsLoading: (loading: boolean) => set({ isLoading: loading }),
      setIsSuccess: (status: boolean) => set({ isSuccess: status }),
      resetCreateEssay: () => set({
        isLoading: false,
        isSuccess: false,
      })
    }),
    {
      name: 'essay-write'
    }
  )
);
